import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class SmartOfferKind extends Cloneable {
    static NONE = new SmartOfferKind(0, "NONE");
    static MASTER = new SmartOfferKind(4, "MASTER");
    static EXPEDITION = new SmartOfferKind(5, "EXPEDITION");
    static MASTER_SEASON = new SmartOfferKind(6, "MASTER_SEASON");
    static EXPEDITION_GROUP = new SmartOfferKind(7, "EXPEDITION_GROUP");

    static _values = [
        this.NONE,
        this.MASTER,
        this.EXPEDITION,
        new SmartOfferKind(1, "EVENT"),
        new SmartOfferKind(2, "OFFER"),
        new SmartOfferKind(3, "FLASH_OFFER"),
        this.MASTER_SEASON,
        this.EXPEDITION_GROUP
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, SmartOfferKind.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof SmartOfferKind) {
            return SmartOfferKind._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return SmartOfferKind.NONE.equal(value);
    }

    constructor(id = 0, name = "DEFAULT") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    equal(value) {
        if (value instanceof SmartOfferKind) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferKind());
        } else if (target instanceof SmartOfferKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});
